import { render } from "./dots-more.svg?vue&type=template&id=3b92f478?inline"
const script = {}
script.render = render

export default script